module.exports = __webpack_public_path__ + "da9ee68b.svg";